import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setPageContaFinanceira, setSelectedRowKeysContaFinanceira } from "../redux/slices/contaFinanceira/contaFinanceiraSlice";
import { setPageLancamentoBancario } from "../redux/slices/lancamentoBancario/lancamentoBancarioSlice";
import { SelectedRowKeysModel } from "../models/sistema/selectedRowKeysModel";

export const cadastrarPagamentoLote = createAsyncThunk("/PagamentoLote/CadastrarPagamentoLote", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/PagamentoLote/CadastrarPagamentoLote", payload.value);
    toastSucess("Operação realizada com sucesso");
    if (payload.origem === "contaFinanceira") {
      dispatch(setSelectedRowKeysContaFinanceira({ rows: [], keys: [] } as SelectedRowKeysModel));
      dispatch(setPageContaFinanceira("geral"));
    } else {
      dispatch(setPageLancamentoBancario("geral"));
    }
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarPagamentoLote = createAsyncThunk("/PagamentoLote/BuscarPagamentoLote", async (idPagamentoLote: number | null) => {
  try {
    const data = await api.get("/PagamentoLote/BuscarPagamentoLote", {
      params: { idPagamentoLote: idPagamentoLote },
    });

    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const deletarTodosPagamentoLote = createAsyncThunk("/PagamentoLote/DeletarTodosPagamentoLote", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/PagamentoLote/DeletarTodosPagamentoLote", {
      params: { idPagamentoLote: payload.value },
    });
    toastSucess("Operação realizada com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPagamentoLote(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
